// http://kazupon.github.io/vue-i18n/en/messages.html
export default {
  '{attribute} can\'t be empty.': '{attribute} can\'t be empty.',
  '{attribute} can\'t contain less than {min} characters.': '{attribute} can\'t contain less than {min} characters.',
  '{attribute} can\'t contain more than {max} characters.': '{attribute} can\'t contain more than {max} characters.',
  '{attribute} should be higher than {min}.': '{attribute} should be higher than {min}.',
  '{attribute} should be a valid e-mail address.': '{attribute} should be a valid e-mail address.',
  '{attribute} should only contain numeric values.': '{attribute} should only contain numeric values.',
  '{0} Product(s)': '{0} Product(s)',
  'Add {0}': 'Add {0}',
  'Add New': 'Add New',
  'Address': 'Address',
  'All': 'All',
  'Amount': 'Amount',
  'Apartment, suite, unit, etc.': 'Apartment, suite, unit, etc.',
  'Are you sure?': 'Are you sure?',
  'Are you sure you want to continue?': 'Are you sure you want to continue?',
  'Articles': 'Articles',
  'Barcode': 'Barcode',
  'Born before: {0}': 'Born before: {0}',
  'Brand': 'Brand',
  'Cart': 'Cart',
  'Cash Management': 'Cash Management',
  'Cash Register': 'Cash Register',
  'Cash Register Code': 'Cash Register Code',
  'Choose a {0}': 'Choose a {0}',
  'Clear': 'Clear',
  'City': 'City',
  'Clear Cart': 'Clear Cart',
  'Completed': 'Completed',
  'Configure this cash register below.': 'Configure this cash register below.',
  'Contact Information': 'Contact Information',
  'Country': 'Country',
  'Customer': 'Customer',
  'Customers': 'Customers',
  'Date': 'Date',
  'Date Of Birth': 'Date Of Birth',
  'Delete': 'Delete',
  'Discount': 'Discount',
  'Does this product contain a tax stamp?': 'Does this product contain a tax stamp?',
  'Email': 'Email',
  'Email Address': 'Email Address',
  'Finish': 'Finish',
  'First Name': 'First Name',
  'General': 'General',
  'Give A Discount': 'Give A Discount',
  'Go Back': 'Go Back',
  'Go to {0}': 'Go to {0}',
  'Installation': 'Installation',
  'Installation Date': 'Installation Date',
  'It looks like this cash register has already been opened.': 'It looks like this cash register has already been opened.',
  'Last Name': 'Last Name',
  'Login': 'Login',
  'Logout': 'Logout',
  'Name': 'Name',
  'No results found.': 'No results found.',
  'Note': 'Note',
  'Number of {0}': 'Number of {0}',
  'Open/Close Register': 'Open/Close Register',
  'Open/Close': 'Open/Close',
  'Open': 'Open',
  'Open Drawer': 'Open Drawer',
  'Opt-In to Marketing and Promotional Emails': 'Opt-In to Marketing and Promotional Emails',
  'Order': 'Order',
  'Order Nr.': 'Order Nr.',
  'Orders': 'Orders',
  'Outstanding Balance': 'Outstanding Balance',
  'Park Receipt': 'Park Receipt',
  'Parked Receipts': 'Parked Receipts',
  'Parked Sales': 'Parked Sales',
  'Pay': 'Pay',
  'Phone': 'Phone',
  'PIN Code': 'PIN Code',
  'Postal Code': 'Postal Code',
  'Price': 'Price',
  'Print': 'Print',
  'Printer': 'Printer',
  'Printerlist': 'Printerlist',
  'Product': 'Product',
  'Products': 'Products',
  'Quantity': 'Quantity',
  'Receipts': 'Receipts',
  'Register Closures': 'Register Closures',
  'Reload {0}': 'Reload {0}',
  'Sales': 'Sales',
  'Sales History': 'Sales History',
  'Save': 'Save',
  'Search': 'Search',
  'Search {0}': 'Search {0}',
  'Select a {0}': 'Select a {0}',
  'Select {0}': 'Select {0}',
  'Settings': 'Settings',
  'Since': 'Since',
  'Subtotal': 'Subtotal',
  'Summary': 'Summary',
  'Staff Note': 'Staff Note',
  'Store': 'Store',
  'Tax Stamp': 'Tax Stamp',
  'The Cart Is Empty.': 'The Cart Is Empty.',
  'The order has been fully paid for': 'The order has been fully paid for',
  'This computer hasn\'t been configured as a cash register yet.': 'This computer hasn\'t been configured as a cash register yet.',
  'This e-mail address is already in our database.': 'This e-mail address is already in our database.',
  'To Refund': 'To Refund',
  'Total': 'Total',
  'Use The Google API For Address Lookup': 'Use The Google API For Address Lookup',
  'Yes': 'Yes',
  'You can find more information about it below.': 'Je kan meer informatie hieronder terugvinden.',
  'VAT': 'VAT',
  'View All': 'View All',
  'Walk In': 'Walk In',
  'Welcome {0}': 'Welcome {0}',
  'When': 'When',
  'Where': 'Where',
  'Why should the drawer be opened?': 'Why should the drawer be opened?'
}
